import * as React from 'react'
import * as plume from '@ulule/owl-kit-components/next'

import { Container } from '../../_shared/Container'
import { MEDIA_OUTLETS, type MediaOutlet } from '../content'
import { SectionHead } from '../../_shared/SectionHead'
import styles from './Media.module.css'

function shuffle(outlets: readonly MediaOutlet[]): MediaOutlet[] {
  const shuffled = [...outlets]
  for (let index = shuffled.length - 1; index > 0; index--) {
    const swapIndex = Math.floor(Math.random() * (index + 1))
    ;[shuffled[index], shuffled[swapIndex]] = [shuffled[swapIndex], shuffled[index]]
  }
  return shuffled
}

export function Media(): React.ReactElement {
  // First render keeps the build-time order so hydration matches the prerendered HTML; the shuffle
  // then runs once, client-side, after hydration — a fresh order on each page load, mismatch-free.
  const [outlets, setOutlets] = React.useState<readonly MediaOutlet[]>(MEDIA_OUTLETS)
  React.useEffect(() => setOutlets(shuffle(MEDIA_OUTLETS)), [])

  return (
    <section className={styles.media}>
      <Container>
        <SectionHead
          size="lg"
          title="Ils parlent de nous 👋"
          lede="Ulule est régulièrement cité dans les grands médias français et internationaux."
        />
        <div className={styles.media__grid}>
          {outlets.map((outlet) => (
            <div key={outlet.name} className={styles.media__cell}>
              <img
                className={styles.media__logo}
                src={outlet.logo}
                alt={outlet.name}
                loading="lazy"
                style={outlet.scale ? ({ '--logo-scale': outlet.scale } as React.CSSProperties) : undefined}
              />
            </div>
          ))}
        </div>
        <div className={styles.media__cta}>
          <plume.RoundButton as="a" href="#contact" color="yellow" size="big">
            Et vous&nbsp;!
          </plume.RoundButton>
        </div>
      </Container>
    </section>
  )
}
